export  const SET_SUB_PROFILE_ID_FROM_STORAGE = 'SET_SUB_PROFILE_ID_FROM_STORAGE';
export  const SET_FROM_STORAGE = 'SET_FROM_STORAGE';
export const SET_AUTH = 'SET_AUTH';
export const SET_USER_DATA = 'SET_USER_DATA';
export const USER_LOADING = 'USER_LOADING';
export const USER_LOADED = 'USER_LOADED';
export  const REMOVE_USER = 'REMOVE_USER';
